/**
 * Created by ObadaDarwish on 08/01/2018.
 */

import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'participantSort'
})

export class SortParticipants implements PipeTransform {
  constructor() {
  }

// sorting teams according to their score in 'pubg' ranking
  transform(participant: any, type: any, bo3: any): any {
    if (participant) {
      if (type === 'FreeForAll') {
        return participant.sort(function (ParticipantA, ParticipantB) {
          const participantA = ParticipantA.score;
          const participantB = ParticipantB.score;

          if (participantA > participantB) {
            return -1;
          } else if (participantA < participantB) {
            return 1;
          } else {
            if (!bo3) {
              if (ParticipantA.damage_rate) {
                let game_rankA = ParticipantA.damage_rate;
                let game_rankB = ParticipantB.damage_rate;

                return game_rankB - game_rankA;
              } else if (ParticipantA.game_rank) {
                let game_rankA = ParticipantA.game_rank;
                let game_rankB = ParticipantB.game_rank;

                if (!game_rankA) {
                  return 1;
                }
                if (!game_rankB) {
                  return -1;
                }

                return game_rankA - game_rankB;
              }

            }
          }
        });

      } else {
        return participant.sort(function (ParticipantA, ParticipantB) {
          let participantA = ParticipantA.rank;
          let participantB = ParticipantB.rank;

          if (participantA > participantB) {
            return 1;
          } else if (participantA < participantB) {
            return -1;
          } else {
            return 0;
          }
        });

      }

    }
  }
}
